import { useTranslation } from 'react-i18next';

import { SHARED_CONSTANTS } from '../../../../Shared/constants/commonConstants';
import { CustomResultsPerPage } from '../../../../UiComponentsLibrary/CustomPagination';
import {
    EnhancedSearchInput, SearchSuggestion
} from '../../../../UiComponentsLibrary/CustomSearchInput';
import { UserManagementFlex } from '../UserManagement.styles';

interface SearchAndPaginationProps {
  handleSearchChange: (value: string) => void;
  searchValue: string;
  currentSize: number;
  handlePageChange: (page: number) => void;
  handlePageSizeChange: (size: number) => void;
  searchSuggestions: SearchSuggestion[];
}

const SearchAndPagination = ({
  handleSearchChange,
  searchValue,
  currentSize,
  handlePageChange,
  handlePageSizeChange,
  searchSuggestions,
}: SearchAndPaginationProps) => {
  const { t } = useTranslation();

  return (
    <UserManagementFlex>
      <EnhancedSearchInput
        id="search-users"
        handleOnChangeCb={handleSearchChange}
        value={searchValue}
        placeholder={t('search-users-field-placeholder')}
        suggestions={searchSuggestions}
        minCharactersForSuggestions={
          SHARED_CONSTANTS.MIN_CHARACTER_LIMIT_TO_TRIGGER_SEARCH
        }
        debounceMs={SHARED_CONSTANTS.SEARCH_DEBOUNCE_TIME}
      />
      <CustomResultsPerPage
        id="results-per-page"
        currentSize={currentSize}
        onPageChangeCb={handlePageChange}
        onPageSizeChangeCb={handlePageSizeChange}
      />
    </UserManagementFlex>
  );
};

export default SearchAndPagination;
